import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Label,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Spinner,
} from 'reactstrap';
import axios from '../utils/posAxios';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';
import {
  MdDone,
  MdWarning,
  MdCancel,
  MdEmail,
  MdCameraAlt,
} from 'react-icons/md';
import { MDBDataTableV5, MDBIcon } from 'mdbreact';
import '@fortawesome/fontawesome-free/css/all.min.css';
import classnames from 'classnames';
import { CSVLink } from 'react-csv';

const tbcolumn = [
  {
    label: 'Invoice No.',
    field: 'invoice_no',
    sort: 'asc',
  },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Invoice Date',
    field: 'invoice_date',
    sort: 'asc',
  },
  {
    label: 'Due Date',
    field: 'due_date',
    sort: 'asc',
  },
  {
    label: 'Terms',
    field: 'terms',
    sort: 'asc',
  },
  {
    label: 'Location',
    field: 'location',
    sort: 'asc',
  },
  {
    label: 'Schedule',
    field: 'schedule',
    sort: 'asc',
  },
  {
    label: 'Memo',
    field: 'memo',
    sort: 'asc',
  },
  {
    label: 'Item(Product/Service)',
    field: 'item',
    sort: 'asc',
  },
  {
    label: 'Item(Description)',
    field: 'item_description',
    sort: 'asc',
  },
  {
    label: 'Item(Quantity)',
    field: 'item_quantity',
    sort: 'asc',
  },
  {
    label: 'Item(Rate)',
    field: 'item_rate',
    sort: 'asc',
  },
  {
    label: 'Item(Amount)',
    field: 'item_amount',
    sort: 'asc',
  },
  {
    label: 'Item(TaxCode)',
    field: 'item_taxcode',
    sort: 'asc',
  },
  {
    label: 'Item(TaxAmount)',
    field: 'item_taxamount',
    sort: 'asc',
  },
  {
    label: 'Currency',
    field: 'currency',
    sort: 'asc',
  },
  {
    label: 'Service Date',
    field: 'service_date',
    sort: 'asc',
  },
];

const headers = [
  {
    label: '*Invoice No.',
    key: 'invoice_no',
  },
  {
    label: '*Customer',
    key: 'customer',
  },
  {
    label: '*Invoice Date',
    key: 'invoice_date',
  },
  {
    label: '*Due Date',
    key: 'due_date',
  },
  {
    label: 'Terms',
    key: 'terms',
  },
  {
    label: 'Location',
    key: 'location',
  },
  {
    label: 'Schedule',
    key: 'schedule',
  },
  {
    label: 'Memo',
    key: 'memo',
  },
  {
    label: 'Item(Product/Service)',
    key: 'item',
  },
  {
    label: 'Item(Description)',
    key: 'item_description',
  },
  {
    label: 'Item(Quantity)',
    key: 'item_quantity',
  },
  {
    label: 'Item(Rate)',
    key: 'item_rate',
  },
  {
    label: '*Item(Amount)',
    key: 'item_amount',
  },
  {
    label: '*Item(TaxCode)',
    key: 'item_taxcode',
  },
  {
    label: 'Item(TaxAmount)',
    key: 'item_taxamount',
  },
  {
    label: 'Currency',
    key: 'currency',
  },
  {
    label: 'Service Date',
    key: 'service_date',
  },
];

const customerHeader = [
  {
    label: 'Category',
    key: 'category'
  },
  {
    label: 'Name',
    key: 'name'
  },
  {
    label: 'Contact',
    key: 'contact'
  },
  {
    label: 'Email',
    key: 'email'
  },
  {
    label: 'Billing Address',
    key: 'billing_address'
  },
  {
    label: 'Billing Unit',
    key: 'billing_unit'
  },
  {
    label: 'Billing Postal Code',
    key: 'billing_postal_code'
  },
  {
    label: 'Service Postal Code',
    key: 'postal_code'
  },
  {
    label: 'Install Date',
    key: 'install_date'
  },
  {
    label: 'Model',
    key: 'model'
  },
  {
    label: 'Serial',
    key: 'serial'
  },
  {
    label: 'Brand',
    key: 'brand'
  },
];

class ExportOrder extends React.Component {
  _isMounted = true;
  orderDetail = StorageService.getSession('exportOrder');
  constructor(props) {
    super(props);
    this.state = {
      //isLoading: true,
      filterList: [],
      // date:
      //   this.orderDetail && this.orderDetail.date
      //     ? this.orderDetail.date
      //     : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      fm_date:
        this.orderDetail && this.orderDetail.fm_date
          ? this.orderDetail.fm_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date:
        this.orderDetail && this.orderDetail.to_date
          ? this.orderDetail.to_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),

      p_fm_date:
        this.orderDetail && this.orderDetail.p_fm_date
          ? this.orderDetail.p_fm_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      p_to_date:
        this.orderDetail && this.orderDetail.p_to_date
          ? this.orderDetail.p_to_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_fm_date:
        this.orderDetail && this.orderDetail.f_fm_date
          ? this.orderDetail.f_fm_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      f_to_date:
        this.orderDetail && this.orderDetail.f_to_date
          ? this.orderDetail.f_to_date
          : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      csvInvoice: [],
      csvPrepaid: [],
      csvFOC: [],
      csvCustomer:[]
    };

    this.csvLinkEl = React.createRef();
    this.csvLinkEl2 = React.createRef();
    this.csvLinkEl3 = React.createRef();
    this.csvLinkEl4 = React.createRef();
  }

  componentDidMount() {
    //this.getOrder();
    // this.CsvInvoice();
    // this.CsvPrepaid();
    // this.CsvFOC();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    let data = this.orderDetail ? this.orderDetail : {};
    data[name] = value;
    StorageService.setSession('exportOrder', data);
    this.getOrder(value);
  };

  searchHandler = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
    let data = this.orderDetail ? this.orderDetail : {};
    data[name] = value;
    StorageService.setSession('exportOrder', data);
    this.orderDetail = StorageService.getSession('exportOrder');

    // if (name === 'fm_date' || name === 'to_date') {
    //   this.CsvInvoice(name, value);
    // }

    // if (name === 'p_fm_date' || name === 'p_to_date') {
    //   this.CsvPrepaid(name, value);
    // }

    // if (name === 'f_fm_date' || name === 'f_to_date') {
    //   this.CsvFOC(name, value);
    // }
  };

  CsvInvoice = async (name, value) => {
    this.setState({ isLoading: true });
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    let fm_date = name === 'fm_date' ? value : this.state.fm_date;
    let to_date = name === 'to_date' ? value : this.state.to_date;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      fm_date: fm_date,
      to_date: to_date,
    };

    axios
      .post(url + ':3003/v3/order/export/custom/szw', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date)
                .tz('Asia/Singapore')
                .format('DD/MM/YYYY');
            }
          }
          // this.setState({
          //   csvInvoice: result.data,
          //   isLoading: false,
          // });
          if (result.data.length > 0) {
            this.setState(
              {
                csvInvoice: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl.current.link.click();
                });
              },
            );
          } else {
            this.CsvNotFound();
          }
        }
      })
      .catch(error => {
        alert(error);
        this.setState({
          isLoading: false,
        });
      });
  };

  CsvPrepaid = async (name, value) => {
    this.setState({ isLoading: true });
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    let fm_date = name === 'p_fm_date' ? value : this.state.p_fm_date;
    let to_date = name === 'p_to_date' ? value : this.state.p_to_date;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      fm_date: fm_date,
      to_date: to_date,
    };

    axios
      .post(url + ':3003/v3/order/export/custom/szw/prepaid', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date)
                .tz('Asia/Singapore')
                .format('DD/MM/YYYY');
            }
          }
          // this.setState({
          //   csvPrepaid: result.data,
          //   isLoading: false,
          // });
          if (result.data.length > 0) {
            this.setState(
              {
                csvPrepaid: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl2.current.link.click();
                });
              },
            );
          } else {
            this.CsvNotFound();
          }
        }
      })
      .catch(error => {
        alert(error);
        this.setState({
          isLoading: false,
        });
      });
  };

  CsvFOC = async (name, value) => {
    this.setState({ isLoading: true });
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    let fm_date = name === 'f_fm_date' ? value : this.state.f_fm_date;
    let to_date = name === 'f_to_date' ? value : this.state.f_to_date;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.match.params.id,
      fm_date: fm_date,
      to_date: to_date,
    };

    axios
      .post(url + ':3003/v3/order/export/custom/szw/foc', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.invoice_date) {
              i.invoice_date = moment(i.invoice_date)
                .tz('Asia/Singapore')
                .format('DD/MM/YYYY');
            }
          }
          // this.setState({
          //   csvFOC: result.data,
          //   isLoading: false,
          // });
          if (result.data.length > 0) {
            this.setState(
              {
                csvFOC: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl3.current.link.click();
                });
              },
            );
          } else {
            this.CsvNotFound();
          }
        }
      })
      .catch(error => {
        alert(error);
        this.setState({
          isLoading: false,
        });
      });
  };

  CsvNotFound() {
    this.setState({ isLoading: false });
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    });
  }

  CsvCustomer = async(name, value) => {
    this.setState({ isLoading: true });
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID
    };

    axios
      .post(url + ':3004/v1/customer/data', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        if (this._isMounted) {
          // for (let i of result.data) {
          //   if (i.invoice_date) {
          //     i.invoice_date = moment(i.invoice_date)
          //       .tz('Asia/Singapore')
          //       .format('DD/MM/YYYY');
          //   }
          // }
          // this.setState({
          //   csvFOC: result.data,
          //   isLoading: false,
          // });
          if (result.data.length > 0) {
            this.setState(
              {
                csvCustomer: result.data,
                isLoading: false,
              },
              () => {
                setTimeout(() => {
                  this.csvLinkEl4.current.link.click();
                });
              },
            );
          } else {
            this.CsvNotFound();
          }
        }
      })
      .catch(error => {
        alert(error);
        this.setState({
          isLoading: false,
        });
      });
  }

  // getOrder = async (date = null) => {
  //   const user = StorageService.getSession('user_info');
  //   const comp = StorageService.getSession('selected_org');
  //   const url = process.env.REACT_APP_UNITY_API2_URL;
  //   const data = {
  //     session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
  //     store_id: this.props.match.params.id,
  //     date: date ? date : this.state.date,
  //   };
  //   console.log(data);
  //   axios
  //     .post(url + ':3003/v1/order/export/custom/szw', data)
  //     .then(response => {
  //       const result = response.data;
  //       if (result.error == true && result.message != 'Success') {
  //         alert(result.message);
  //         return;
  //       }
  //       if (this._isMounted) {
  //         for (let i of result.data) {
  //           if (i.invoice_date) {
  //             i.invoice_date = moment(i.invoice_date)
  //               .tz('Asia/Singapore')
  //               .format('DD/MM/YYYY');
  //           }
  //         }
  //         this.setState({
  //           filterList: result.data,
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       alert(error);
  //     });
  // };

  render() {
    const data = {
      columns: tbcolumn,
      rows: this.state.filterList,
    };
    return (
      <>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}
          >
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Invoice Report (Based on Service Date)</p>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Start Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="fm_date"
                  value={this.state.fm_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="to_date"
                  value={this.state.to_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col
              md={5}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}
            >
              {/* <Button type="submit" className="ps-input-small">
                Search
              </Button> */}

              {/* <CSVLink
                data={this.state.csvInvoice}
                headers={headers}
                filename={
                  'invoice_' +
                  moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                onClick={() => {
                  if (this.state.csvInvoice.length < 1) {
                    this.CsvNotFound();
                    return false;
                  }
                }}
              >
                <Button
                  type="button"
                  className="ps-input-small theme-button-primary"
                >
                  Export
                </Button>
              </CSVLink> */}

              <Button
                type="button"
                className="ps-input-small theme-button-primary"
                disabled={this.state.isLoading}
                onClick={this.CsvInvoice}
              >
                Export
              </Button>
              <CSVLink
                headers={headers}
                filename={
                  'invoice_' +
                  moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                data={this.state.csvInvoice}
                ref={this.csvLinkEl}
              />
            </Col>
          </Row>
        </Form>

        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Pre-Paid Invoice Report (Based on Invoice Date)</p>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Start Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="p_fm_date"
                  value={this.state.p_fm_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="p_to_date"
                  value={this.state.p_to_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col
              md={5}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}
            >
              {/* <Button type="submit" className="ps-input-small">
                Search
              </Button> */}

              {/* <CSVLink
                data={this.state.csvPrepaid}
                headers={headers}
                filename={
                  'prepaid_invoice_' +
                  moment(this.state.p_fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.p_to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                onClick={() => {
                  if (this.state.csvPrepaid.length < 1) {
                    this.CsvNotFound();
                    return false;
                  }
                }}
              >
                <Button
                  type="button"
                  className="ps-input-small theme-button-primary"
                >
                  Export
                </Button>
              </CSVLink> */}

              <Button
                type="button"
                className="ps-input-small theme-button-primary"
                disabled={this.state.isLoading}
                onClick={this.CsvPrepaid}
              >
                Export
              </Button>
              <CSVLink
                headers={headers}
                filename={
                  'prepaid_invoice_' +
                  moment(this.state.p_fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.p_to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                data={this.state.csvPrepaid}
                ref={this.csvLinkEl2}
              />
            </Col>
          </Row>
        </Form>

        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export FOC Report (Based on Service Date)</p>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <Label>Start Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="f_fm_date"
                  value={this.state.f_fm_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="f_to_date"
                  value={this.state.f_to_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col
              md={5}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}
            >
              {/* <Button type="submit" className="ps-input-small">
                Search
              </Button> */}

              {/* <CSVLink
                data={this.state.csvFOC}
                headers={headers}
                filename={
                  'foc_invoice_' +
                  moment(this.state.f_fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.f_to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                onClick={() => {
                  if (this.state.csvFOC.length < 1) {
                    this.CsvNotFound();
                    return false;
                  }
                }}
              >
                <Button
                  type="button"
                  className="ps-input-small theme-button-primary"
                >
                  Export
                </Button>
              </CSVLink> */}

              <Button
                type="button"
                className="ps-input-small theme-button-primary"
                disabled={this.state.isLoading}
                onClick={this.CsvFOC}
              >
                Export
              </Button>
              <CSVLink
                headers={headers}
                filename={
                  'foc_invoice_' +
                  moment(this.state.f_fm_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '_' +
                  moment(this.state.f_to_date, 'YYYY-MM-DD').format('YYMMDD') +
                  '.csv'
                }
                data={this.state.csvFOC}
                ref={this.csvLinkEl3}
              />
            </Col>
          </Row>
        </Form>

        <Form>
          <Row>
            <Col style={{ margin: 0 }}>
              <p>Export Customer Data</p>
            </Col>
          </Row>
          <Row>
            {/* <Col md={3}>
              <FormGroup>
                <Label>Start Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="f_fm_date"
                  value={this.state.f_fm_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label>End Date</Label>
                <Input
                  className="ps-input-small"
                  type="date"
                  name="f_to_date"
                  value={this.state.f_to_date}
                  onChange={this.searchHandler}
                  disabled={this.state.isLoading}
                  required
                />
              </FormGroup>
            </Col> */}
            <Col
              md={5}
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingTop: '12px',
              }}
            >
              <Button
                type="button"
                className="ps-input-small theme-button-primary"
                disabled={this.state.isLoading}
                onClick={this.CsvCustomer}
              >
                Export
              </Button>
              <CSVLink
                headers={customerHeader}
                filename={
                  'customer_' + moment(new Date(), 'YYYY-MM-DD').format('YYYYMMDD') +'.csv'
                }
                data={this.state.csvCustomer}
                ref={this.csvLinkEl4}
              />
            </Col>
          </Row>
        </Form>

        {/* <MDBDataTableV5
          className="ps-order-table"
          data={data}
          displayEntries={false}
          searchTop
          searchBottom={false}
          noRecordsFoundLabel="No data to show"
          fullPagination
          responsive={true}
        /> */}
      </>
    );
  }
}

export default ExportOrder;
